import { querySelectorAll } from '../helpers'

export function initializeSkipTo() {
  querySelectorAll<HTMLFormElement>('form.results-skip').forEach((form) => {
    querySelectorAll<HTMLSelectElement>('select', form).forEach((select) => {
      select.addEventListener('change', () => {
        const value = Array.from(select.selectedOptions)[0].value

        if (value) {
          const type = select.name
          const id = `${type}-${value.replace(/\s/g, '')}`
          const target = document.querySelector<HTMLDivElement>(`#${id}`)

          if (target) {
            window.location.hash = id
            window.scrollTo({
              behavior: 'smooth',
              left: 0,
              top: target.getBoundingClientRect().top + window.scrollY - 60,
            })
            target.classList.add('selected')
            setTimeout(() => {
              target.classList.remove('selected')
            }, 2500)
          }
        }
      })
    })
  })
}
